import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import moment from 'moment'
import { BehaviorSubject, interval, Subscription } from 'rxjs'
import { MomentPipe } from '../../../pipes/moment.pipe'
import { RouterService } from '../../../services/router.service'

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MomentPipe, TranslateModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription()

  date = moment()
  time$ = new BehaviorSubject<string>(this.date.format('LT'))

  @Input() title = ''

  constructor(private routerService: RouterService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      interval(1000).subscribe(() => {
        this.time$.next(moment().format('LT'))
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  goToPreviousPage(): void {
    this.routerService.goToHome()
  }
}
